// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"24fd2dbc","988":"322f3d4c"}[chunkId] + ".chunk.css";
};